




























































import { Component, Vue, Watch } from 'vue-property-decorator';
import { workspaceService } from '@/services/WorkspaceService';
import { accountSettingsService } from '@/services/AccountSettingsService';
import EventBus from '@/EventBus';
import { mapGetters, mapState } from 'vuex';

@Component({
  props: ['isInSettings', 'isInAccount', 'isInNewWorkspace', 'isInPreparations', 'isInWorkspaceSwitch'],
  computed: {
    ...mapState({
      workspaces: (state: any) => state.workspaces.workspaces,
      workspaceData: (state: any) =>
        state.workspaces.workspaces.find(
          (item: any) => parseInt(item.id, 10) === parseInt(state.currentWorkspace.id, 10)
        ) || {},
    }),
    ...mapGetters('workspaces', { getWorkspace: 'getWorkspaceById' }),
  },
})
export default class Header extends Vue {
  isMenuOpen = false;
  user: any = {};
  workspace: any = {};
  workspaceId = 0;
  regionId = 0;
  isLoading = false;
  errors: any = [];

  onClose() {
    this.errors = [];
  }

  @Watch('$route.params.workspaceId')
  onWorkspaceChange() {
    this.workspaceId = parseInt(this.$route.params.workspaceId, 10);
  }

  mounted() {
    this.workspaceId = parseInt(this.$route.params.workspaceId, 10);
    this.regionId = parseInt(this.$route.params.regionId, 10);

    document.addEventListener('click', () => {
      this.isMenuOpen = false;
    });
    this.$store.dispatch('workspaces/getWorkspaces').then(() => {
      this.workspace = this.$store.getters['workspaces/getWorkspaceById'](this.workspaceId);
    });

    this.getSettings();
    EventBus.$on('workspace-name-change', (name: string) => {
      this.workspace.name = name;
    });
    EventBus.$on('user-name-changed', (name: string) => {
      this.user.name = name;
    });
  }
  goBack() {
    if (this.$route.query.back) {
      this.$router.push(this.$route.query.back as string).catch(() => {});
    } else {
      this.$router.push('/').catch(() => {});
    }
  }
  getSettings() {
    accountSettingsService
      .getSettings()
      .then((data: any) => {
        this.user = data;
      })
      .catch(() => {});
  }
  goToAccountSettings() {
    this.$router
      .push({
        path: '/account-settings',
        query: { back: this.$route.query && this.$route.query.back ? this.$route.query.back : this.$route.fullPath },
      })
      .catch(() => {});
  }
}
